
<div class="container">
  <mat-card appearance="outlined" *ngFor="let calculatorLink of calculationTypes; let i = index"
            class="card-radius card-container roof-type-card">
    <mat-card-header>
      <mat-card-title>{{ calculatorLink.title }}</mat-card-title>
    </mat-card-header>
    <mat-card-content class="grow-content" [innerHtml]="calculatorLink.subText"></mat-card-content>
    <mat-card-content>
      <div class="centered-content">
        <a [routerLink]="calculatorLink.link">
          <img mat-card-image class="image" [src]="calculatorLink.imgLink" alt="slope" />
        </a>
      </div>
    </mat-card-content>
    <mat-card-actions class="calculator-buttons">
      <a [routerLink]="calculatorLink.link" mat-raised-button color="primary" gaEvent="calculation_type_link" gaCategory="buttons_tracking">
        {{calculatorLink.linkText}}
        <!--googleoff: index-->
        <mat-icon iconPositionEnd>arrow_forward_ios</mat-icon>
        <!--googleon: index-->
      </a>
    </mat-card-actions>
  </mat-card>
</div>
